import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthCallback } from './components/AuthCallback';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { SchoolsPage } from './pages/SchoolsPage';
import { StudentsPage } from './pages/StudentsPage';
import { AIPlaygroundPage } from './pages/AIPlaygroundPage';
import InterventionsLaunchPage from './pages/InterventionsLaunchPage';
import IEPMETProductPage from './pages/IEPMETProductPage';
import IEPMETCaseDetail from './pages/IEPMETCaseDetail';
import LinkedDocumentDetail from './pages/LinkedDocumentDetail';
import StudentTimeline from './pages/StudentTimeline';
import LegalPage from './pages/LegalPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { Toaster } from './components/ui/sonner';

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id (Google OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/organizations" 
        element={
          <ProtectedRoute>
            <OrganizationsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/schools" 
        element={
          <ProtectedRoute>
            <SchoolsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/students" 
        element={
          <ProtectedRoute>
            <StudentsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/ai-playground" 
        element={
          <ProtectedRoute>
            <AIPlaygroundPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/products/interventions" 
        element={
          <ProtectedRoute>
            <InterventionsLaunchPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/products/iep-met" 
        element={
          <ProtectedRoute>
            <IEPMETProductPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/products/iep-met/cases/:caseId" 
        element={
          <ProtectedRoute>
            <IEPMETCaseDetail />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/products/iep-met/documents/:documentId" 
        element={
          <ProtectedRoute>
            <LinkedDocumentDetail />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/products/iep-met/students/:studentId/timeline" 
        element={
          <ProtectedRoute>
            <StudentTimeline />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/products" 
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/users" 
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
